import { useEffect, useState } from 'react';

import { isWeb } from '@/utils/constants-platform-specific';
import { logger } from '@/utils/logging';
import { load } from '@fingerprintjs/botd';

const botdPromise = isWeb ? load() : null;

/**
 * Custom hook to detect if the user is a bot using FingerprintJS Bot Detection, only available on web.
 */
export function useBotDetection() {
    const [isBot, setIsBot] = useState(false);
    const [isLoading, setIsLoading] = useState<boolean>(isWeb);

    useEffect(() => {
        if (!isWeb || !botdPromise) {
            setIsLoading(false);
            return;
        }

        const detectBot = async () => {
            try {
                const botd = await botdPromise;
                const result = await botd.detect();
                setIsBot(result.bot);
            } catch (error) {
                logger.debug('[BotD]', 'BotD failed to detect', error);
                setIsBot(false);
            } finally {
                setIsLoading(false);
            }
        };

        detectBot();
    }, []);

    return { isBot, isLoading };
}
